import Vue from 'vue';
import Router from 'vue-router';
import routerConfig from '@/config/router';
import appConfig from '@/config/app';

Vue.use(Router);

const createRouter = () => new Router({
  mode: appConfig.routeMode,
  scrollBehavior: () => ({ y: 0 }),
  routes: routerConfig.routes
})

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/core/router.js